import { Component } from '@angular/core';
import { User } from 'src/app/shared/models/user';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {
  constructor(
    private userService: UserService,
  ) { }

  users?: User[];

  async ngOnInit() {
    this.users = await this.userService.getUsers();
  }

  isAdmin(user: User) {
    // TODO: replace `0` with constant?
    return user.role === 0;
  }
}
